<template>
<div class="container padding-top">
    <div class="left-nav">
        <div class="black-title">
            我的已购
        </div>
        <ul class="nav">
            <li @click="changeType(1)" :class="uType == 1?'active':''">已购书籍</li>
            <li @click="changeType(2)" :class="uType == 2?'active':''">会员信息</li>
            <li @click="changeType(3)" :class="uType == 3?'active':''">订阅记录</li>
            <li @click="changeType(4)" :class="uType == 4?'active':''">关注主播</li>
            <li @click="changeType(5)" :class="uType == 5?'active':''">使用激活码</li>
        </ul>
    </div>
    <div class="right-content">
        <div v-if="uType == 2">
            <div class="userhead">
                <img class="head-img" v-if="$store.state.userInfo.faceUrl" :src="$store.state.userInfo.faceUrl | objs" />
                
            </div>
            <div class="user-name">{{$store.state.userInfo.userName?$store.state.userInfo.userName:$store.state.userInfo.loginName}}</div>
            <div class="user-line" v-if="$store.state.userInfo.tel">手机号：{{$store.state.userInfo.tel}}</div>
            <div class="user-line">客服电话：400-030-6696</div>
            <div class="user-line">官方网站：www.auto-learning.com</div>
            <div class="user-line" v-if="$store.state.userInfo.vipInfo.vipExpired">
            <p>您的VIP截止日期为：<span v-html="$store.state.userInfo.vipInfo.vipExpired"></span></p>
            <div>在此期间，您可以无限畅听路上畅听APP独家制作的所有音频书籍（此付费收听范围不包括名师讲堂等合作方收费节目）</div>
            </div>
            <div class="userhead">
                <p><button @click="loginOut()">退出登录</button></p></div>
        </div>

        <div v-if="uType == 1">
            <div class="w25" v-for="item in list" :key="item.bookId">
                <img class="book-img" :src="item.faceImgPlay | objs"  @click="$store.dispatch('bookplay',item.bookId)"/>
                <router-link :to="{path:'/bookdetail',query:{bookId:item.bookId}}">
                <div class="book-title">{{item.bookName}}</div>
                <div class="writer">[{{item.nationName}}]{{item.author}}</div>
                </router-link>
            </div>
            <div><button class="more" v-if="moreList" @click="moreBook">加载更多></button></div>
        </div>

         <div v-if="uType == 3">
            <div v-for="(item,index) in accountList" :key="index"> 
            <div v-if="item.month.length > 1">
              <div class="weekbg">{{item.month}}</div>
            </div>
            <div v-else>
                <div v-if="item.buyType == 0">
                      <div class="list">
                        <span class="time">{{item.dateTime}}</span>
                        <span class="title">{{item.costYuan}}</span>
                        <span class="details">{{item.describle}}</span>
                      </div>
                  </div>
              <div v-if="item.buyType == 1">
                <router-link :to="{path:'/bookdetail',query:{bookId:item.bookId}}">
                  <div class="list">
                  <img v-bind:src="item.faceImg | objs" />
                    <span class="time">{{item.dateTime}}</span>
                    <span class="title">{{item.costYuan}}</span>
                    <span class="details">{{item.describle}}</span>
                  </div>
                </router-link>
              </div>
              <div v-if="item.buyType == 2 || item.buyType == 3"> 
                <router-link :to="{path:'/booklist',query:{listId:item.objId}}">
                  <div class="list"> 
                    <span class="time">{{item.dateTime}}</span>
                    <span class="title">{{item.costYuan}}</span>
                    <span class="details">{{item.describle}}</span>
                  </div>
                </router-link>
              </div> 
            </div> 
            </div>
            <div><button class="more" v-if="moreAccountList" @click="moreAccount">加载更多></button></div>
        </div>
        <div v-if="uType ==4">
            <div v-for="item in favourList" :key="item.id">
                <router-link :to="{path:'/anchorinfo',query:{id:item.id}}">
                  <img class="myanchor_img" v-bind:src="item.face | objs" />
                  <div class="anchor_info">
                      <div class="myanchor_name">{{item.name}} <span class='zbarea'> 共播音：{{item.bookNum}} 本 </span></div>
                      <div class="myanchor_introduce">{{item.intro}}</div>
                  </div>
                </router-link>
            </div>
             
        </div>
    </div>
</div>
</template>

<script>
import {getCookie,setCookie} from '@/network/cookie.js'
var mybooklist;
var accountList = [];
export default {
    metaInfo() {
        return{
        title: '路上畅听会员中心' + this.$store.state.title,
        meta: [
          { vmid: 'keywords', name: 'keywords', content: this.$store.state.keywords },
          { vmid: 'description', name: 'description', content: this.$store.state.description }
        ] 
        }
    },
    data() {
        return {
            uType: 1,
            list: [],
            moreList:true,
            accountList:[],
            moreAccountList:true,
            favourList:[],
            pageIndex:0,
            pageIndexAccount:0
        }
    },
    methods:{
        changeType:function(t){
            this.uType = t;
            if(t==5){
                this.$store.commit('showLogin'); 
            }
        },
        moreBook:function(){
            this.pageIndex++;
            this.myAuthorware();
        },
        moreAccount:function(){
            this.pageIndexAccount++;
            this.myPayList();
        }, 
        myAuthorware:function(){
            var that = this;
            this.$http.get({url:'/xcx/user-authorware?sessionId='+getCookie('sessionId')+'&pageIndex='+this.pageIndex +'&pageSize=30'}).then(res=>{
                if(res.data.data.length > 0){ 
                    for(var i in res.data.data){
                        mybooklist.push(res.data.data[i])
                    }
                    that.list = mybooklist;
                }else{
                    this.moreList = false
                }
            }) 
        },
        myPayList:function(){
            var that = this;
            this.$http.get({url:'/xcx/user-account?sessionId='+getCookie('sessionId')+'&pageIndex='+this.pageIndexAccount +'&pageSize=30'}).then(res=>{
                if(res.data.data.length > 0){ 
                    for(var i in res.data.data){
                        accountList.push(res.data.data[i])
                    }
                    that.accountList = accountList;
                }else{
                    this.moreAccountList = false
                }
            }) 
        },
        myFavourList:function(){ 
            this.$http.get({url:'/xcx/my-favour-anchor?sessionId='+getCookie('sessionId')+'&pageIndex='+this.pageIndexAccount +'&pageSize=100'}).then(res=>{
                this.favourList = res.data.data; 
            }) 
        },
        loginOut:function(){
            setCookie('sessionId','')
            this.$store.state.userInfo = {}
            this.$router.push({path:'/home'})
        }
    },
    mounted(){
            this.myAuthorware();
            this.myPayList();
            this.myFavourList();
            if(!getCookie('sessionId')){
                this.$router.push({path:'/home'})
            }
            mybooklist = []
        }
}
</script>

<style scoped>
a{text-decoration: none;}
.padding-top {
    padding-top: 50px;
}

.black-title {
    width: 200px;
    height: 60px;
    line-height: 60px;
    text-align: center;
    background: #242926;
    border-radius: 2px;
    font-size: 20px;
    font-family: Source Han Serif CN;
    font-weight: bold;
    color: #FFFFFF;

}

.left-nav {
    width: 200px;
    height: auto;
    background: #FFFFFF;
    box-shadow: 4px 4px 23px 1px rgba(173, 195, 189, 0.26);
    border-radius: 2px;
    float: left;
}

.right-content {
    width: 800px;
    padding: 30px;
    height: auto;
    overflow: hidden;
    background: #F9F9F9;
    float: right;
}

.nav {
    list-style: none;
    padding: 0;
}

.nav li {
    height: 80px;
    line-height: 80px;
    text-align: center;
    font-size: 18px;
    font-family: Source Han Serif CN;
    font-weight: 600;
    color: #242926;
    cursor: pointer;
}

.nav li:hover,
.active {
    height: 80px;
    background: #EDFAF6;
    border-radius: 2px;
    font-size: 18px;
    font-family: Source Han Serif CN;
    font-weight: bold;
    color: #4BCCAA !important;

}

/**已购书 */
.w25 {
    width: 25%;
    height: 230px;
    float: left;
}

.book-img {
    width: 144px;
    height: 144px;
    background: #FFFFFF;
    box-shadow: 8px 8px 28px 1px rgba(173, 195, 189, 0.33);
    border-radius: 2px;
}

.book-title {
    height: 30px;
    overflow: hidden;
    font-size: 16px;
    font-family: PingFang SC;
    font-weight: 800;
    color: #242926;
}

.writer {
    height: 14px;
    overflow: hidden;
    font-size: 12px;
    font-family: PingFang SC;
    font-weight: 400;
    color: #869394;
}

/**会员信息 */
.userhead{text-align: center;}
.head-img { 
    border: 1px;
    border-radius: 40px;
    width: 80px;
    height: 80px;

}

.user-name {
    height: 60px; 
    padding: 0 30px;
    text-align: center;
    font-size: 16px;
    font-family: PingFang SC;
    font-weight: 800;
    border-bottom:1px dashed #869394;
}
.user-line{padding: 20px; border-bottom:1px dashed #869394;}
.more{margin-top: 60px; 
color:rgba(75,204,170,1); background: none; padding: 5px 10px; border: 1px solid rgba(75,204,170,1); border-radius: 3px; cursor: pointer;}
.more:hover{ background: #4bcdab; color: #fff;}
/*帐户信息*/

.sum{width: 50%; float: left; text-align: center; font-size: 24px;}
.list{width: 100%;  border-bottom: 1px solid #f1f5f4; padding: 10px 0; overflow: hidden;} 
.list img{width: 60px; height: 60px; float: left; margin-left: 15px;}
.time{float: right; width: 140px; text-align: right;padding:5px 15px 0 0; color: #7c7c7c; font-size: 14px;}
.title{font-size: 21px; font-weight: 600; color: #000; padding-left: 15px}
.details{margin-right: 14px; display: flex; padding: 5px 10px 0 15px;  color:#7c7c7c; line-height: 140%; font-size: 14px}
.weekbg{background: #f1f5f4; text-align: center;}

/*主播详情*/
a{color: #323433;}
.anchor_info { 
  margin-bottom: 10px; 
  padding-bottom: 30px;
  border-bottom: 1px dashed #869394;
  margin-left: 10px;
}
 
.myanchor_img {
    width: 56px;
    height: 56px;
    border-radius: 50%;
    margin-right: 30px;
    float: left;

}
 

.myanchor_name { 
    font-size: 16px;
    white-space: nowrap;
    overflow: hidden;
    margin-top: 12px; 
}

.myanchor_introduce { 
    font-size: 12px;
    white-space: nowrap;
    text-overflow: ellipsis;
    overflow: hidden;
    margin-top: 10px;
}
</style>
